'use client';
import { useMeasure } from "@uidotdev/usehooks";
import { PDFViewer } from "@/components/ui/pdf-viewer"

import Image from "next/image";
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "@/components/ui/tooltip"
import { InvoicePreviewProps } from "./invoice-preview.types";
import { FileIcon } from "lucide-react";
import { isPdf, isImage } from "@/utils/file-type";
import { InvoiceExtended } from "@/types";

const InvoicePreview: React.FC<InvoicePreviewProps> = ({ invoice }) => {
    const { invoiceId } = invoice as InvoiceExtended;
    const [_ref, { width, height }] = useMeasure();

    return <TooltipProvider delayDuration={0}>
        <Tooltip>
            <TooltipTrigger asChild>
                <div className="flex items-center gap-2">
                    <FileIcon className="size-4" aria-hidden="true" color="gray" />
                    <span className="text-xs font-semibold">Invoice {invoiceId}</span>
                </div>

            </TooltipTrigger>
            <TooltipContent side="left">
                {invoice.documentUrl && (
                    <>
                        {isPdf(invoice.documentUrl) && 
                            <PDFViewer width={width || undefined} documentUrl={invoice.documentUrl}></PDFViewer> }
                        {isImage(invoice.documentUrl) && 
                            <Image fill={true} alt="Invoice Preview" className="border border-gray-300 max-w-[600px]" src={invoice.documentUrl} width={width || undefined} height={height || undefined} />}
                    </>
                )}
            </TooltipContent>
        </Tooltip>
    </TooltipProvider>
}

export { InvoicePreview };